// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1CSJC","colMaxWidth":"Table_colMaxWidth__F_c8g"};